import { render } from "./First_loader.vue?vue&type=template&id=3d00924e"
const script = {}

import "./First_loader.vue?vue&type=style&index=0&id=3d00924e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__